// extracted by mini-css-extract-plugin
export default {"allservice":"AllService_allservice__HeMok","allImg":"AllService_allImg__5ljCL"};